// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

const DownloadAppsSvg = () => (
    <svg
        width='168'
        height='119'
        viewBox='0 0 168 119'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M66.8589 108C102.148 108 130.755 106.964 130.755 105.687C130.755 104.409 102.148 103.373 66.8589 103.373C31.5698 103.373 2.9624 104.409 2.9624 105.687C2.9624 106.964 31.5698 108 66.8589 108Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <path
            d='M141.5 119C153.926 119 164 117.881 164 116.5C164 115.119 153.926 114 141.5 114C129.074 114 119 115.119 119 116.5C119 117.881 129.074 119 141.5 119Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <path
            d='M13.2399 86H130.746C131.178 86.0001 131.605 85.9135 132.003 85.7453C132.401 85.5771 132.762 85.3306 133.065 85.0203C133.368 84.7099 133.606 84.3419 133.767 83.9376C133.927 83.5333 134.006 83.1009 134 82.6654V3.33458C134.006 2.89913 133.927 2.46666 133.767 2.06238C133.606 1.6581 133.368 1.29007 133.065 0.97973C132.762 0.669392 132.401 0.422953 132.003 0.254751C131.605 0.0865491 131.178 -5.37496e-05 130.746 2.50274e-08H13.2538C12.8222 -5.37496e-05 12.395 0.0865491 11.9969 0.254751C11.5988 0.422953 11.2378 0.669392 10.935 0.97973C10.6323 1.29007 10.3937 1.6581 10.2332 2.06238C10.0728 2.46666 9.99362 2.89913 10.0004 3.33458V82.6654C9.99363 83.0997 10.0723 83.531 10.2319 83.9344C10.3915 84.3377 10.6289 84.7051 10.9302 85.0153C11.2315 85.3254 11.5908 85.5722 11.9872 85.7412C12.3837 85.9102 12.8095 85.9982 13.2399 86V86Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M13.2399 86H130.746C131.178 86.0001 131.605 85.9135 132.003 85.7453C132.401 85.5771 132.762 85.3306 133.065 85.0203C133.368 84.7099 133.606 84.3419 133.767 83.9376C133.927 83.5333 134.006 83.1009 134 82.6654V3.33458C134.006 2.89913 133.927 2.46666 133.767 2.06238C133.606 1.6581 133.368 1.29007 133.065 0.97973C132.762 0.669392 132.401 0.422953 132.003 0.254751C131.605 0.0865491 131.178 -5.37496e-05 130.746 2.50274e-08H13.2538C12.8222 -5.37496e-05 12.395 0.0865491 11.9969 0.254751C11.5988 0.422953 11.2378 0.669392 10.935 0.97973C10.6323 1.29007 10.3937 1.6581 10.2332 2.06238C10.0728 2.46666 9.99362 2.89913 10.0004 3.33458V82.6654C9.99363 83.0997 10.0723 83.531 10.2319 83.9344C10.3915 84.3377 10.6289 84.7051 10.9302 85.0153C11.2315 85.3254 11.5908 85.5722 11.9872 85.7412C12.3837 85.9102 12.8095 85.9982 13.2399 86V86Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.72'
        />
        <path
            d='M0 97C0 101 3.21676 105 7.14114 105H135.864C139.588 105 143 101.009 143 97H0Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M0 97C0 101 3.21676 105 7.14114 105H135.864C139.588 105 143 101.009 143 97H0Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.72'
        />
        <path
            d='M131.083 86H11.9171L0 97H143L131.083 86Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M131.083 86H11.9171L0 97H143L131.083 86Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <path
            d='M128.001 87H15.9941L12 91H132L128.001 87Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <path
            d='M84.1735 94H59.8265L58 96H86L84.1735 94Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.72'
        />
        <path
            d='M127 7H17V78H127V7Z'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='17'
            y='7'
            width='23'
            height='71'
            fill='var(--sidebar-bg)'
        />
        <circle
            opacity='0.32'
            cx='21.1863'
            cy='10.384'
            r='2'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='24'
            y='10'
            width='14'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='16.384'
            width='17'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='19.384'
            width='11'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='22.384'
            width='16'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='25.384'
            width='13'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='28.384'
            width='18'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='31.384'
            width='9'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='34.384'
            width='18'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.32'
            x='20.1863'
            y='37.384'
            width='13'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <circle
            cx='46.1863'
            cy='23.5272'
            r='3'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <circle
            cx='46.1863'
            cy='39.5272'
            r='3'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <circle
            cx='46.1863'
            cy='55.5272'
            r='3'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='20.5272'
            width='15'
            height='2'
            rx='1'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='36.5272'
            width='15'
            height='2'
            rx='1'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='52.5272'
            width='15'
            height='2'
            rx='1'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='24.5272'
            width='54'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='40.5272'
            width='54'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='56.5272'
            width='54'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='27.5272'
            width='60'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='43.5272'
            width='60'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='59.5272'
            width='60'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='30.5272'
            width='37'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='46.5272'
            width='37'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='51.1863'
            y='62.5272'
            width='37'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='98.1863'
            y='10'
            width='14'
            height='2'
            rx='1'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='43.1863'
            y='10'
            width='14'
            height='2'
            rx='1'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='91.1863'
            y='9'
            width='4'
            height='4'
            rx='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='121.186'
            y='9'
            width='4'
            height='4'
            rx='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='115.186'
            y='9'
            width='4'
            height='4'
            rx='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='85.1863'
            y='9'
            width='4'
            height='4'
            rx='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='43'
            y='71'
            width='79'
            height='4'
            rx='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <path
            d='M71.7666 1.85419C72.1361 1.85419 72.4973 1.96376 72.8046 2.16904C73.1118 2.37432 73.3512 2.66609 73.4926 3.00746C73.634 3.34882 73.6711 3.72447 73.599 4.08686C73.5269 4.44926 73.349 4.78212 73.0877 5.0434C72.8264 5.30467 72.4935 5.4826 72.1311 5.55469C71.7687 5.62677 71.3931 5.58979 71.0518 5.44839C70.7104 5.30699 70.4186 5.06752 70.2133 4.7603C70.008 4.45308 69.8984 4.09188 69.8984 3.72238C69.8984 3.22691 70.0953 2.75172 70.4456 2.40137C70.796 2.05101 71.2712 1.85419 71.7666 1.85419Z'
            fill='var(--center-channel-bg)'
            fillOpacity='0.32'
        />
        <path
            d='M82.3863 102H61.609C60.8944 102 59 102 59 100H85C85 102 83.0445 102 82.3863 102Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.72'
        />
        <path
            d='M161.803 111.909C161.803 114.344 159.414 116.784 157.025 116.784H125.969C123.581 116.784 121.192 114.344 121.192 111.909V40.094C121.192 37.6564 123.578 35.2188 125.967 35.2188H157.025C159.414 35.2188 161.803 37.6564 161.803 40.094V111.909Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M161.803 111.909C161.803 114.344 159.414 116.784 157.025 116.784H125.969C123.581 116.784 121.192 114.344 121.192 111.909V40.094C121.192 37.6564 123.578 35.2188 125.967 35.2188H157.025C159.414 35.2188 161.803 37.6564 161.803 40.094V111.909Z'
            fill='var(--center-channel-color)'
        />
        <path
            d='M145 39.4989C145 39.776 144.847 40 144.653 40H138.35C138.159 40 138 39.7691 138 39.4989C138 39.2286 138.159 39 138.35 39H144.642C144.836 39 145 39.224 145 39.4989Z'
            fill='var(--center-channel-bg)'
            fillOpacity='0.32'
        />
        <path
            d='M160 44H123V108H160V44Z'
            fill='var(--center-channel-bg)'
        />
        <circle
            cx='127.5'
            cy='56.5'
            r='2.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <circle
            cx='127.5'
            cy='71.5'
            r='2.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <circle
            cx='127.5'
            cy='86.5'
            r='2.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='55'
            width='17'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='70'
            width='17'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='85'
            width='17'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='61'
            width='24'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='76'
            width='24'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='91'
            width='24'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='64'
            width='12'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='79'
            width='12'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='94'
            width='12'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='58'
            width='26'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='73'
            width='26'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='131'
            y='88'
            width='26'
            height='1'
            rx='0.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='123'
            y='44'
            width='37'
            height='7'
            fill='var(--sidebar-bg)'
        />
        <rect
            opacity='0.48'
            x='129'
            y='47'
            width='12'
            height='1'
            rx='0.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.48'
            x='155'
            y='46'
            width='3'
            height='3'
            rx='1.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            opacity='0.48'
            x='125'
            y='46'
            width='3'
            height='3'
            rx='1.5'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='137'
            y='111'
            width='10'
            height='2'
            rx='1'
            fill='var(--center-channel-bg)'
            fillOpacity='0.32'
        />
    </svg>
);

export default DownloadAppsSvg;
